import styled, { css } from 'styled-components';
import { Box } from '@scope/scope-one-ui/core';
import { SIZES } from '@scope/scope-one-ui/theme';
import { DotProps } from './ClimateChangeRisk.d';

export const ChartContainer = styled(Box)`
  > div {
    width: ${SIZES.spacing(36)};
    height: ${SIZES.spacing(32)};
  }
`;

export const Dot = styled(Box)<DotProps>(
  ({ color }) => css`
    border-radius: 50%;
    flex-shrink: 0;
    width: ${SIZES.spacing(1.5)};
    height: ${SIZES.spacing(1.5)};
    background-color: ${color};
  `,
);
